module.exports = __webpack_public_path__ + "img/yh.cc759946.png";